export const hasParcels = parcels => parcels?.length > 0
